import axios from "axios";
export default {
  name: "instagramSection",
  data() {
    return {
      instaData: [],
    };
  },
  created() {
    axios
      .get("https://giftstore-blog.herokuapp.com/api/instagram/posts")
      .then((response) => {
        console.log("instagram", response.data.url);
        this.instaData = response.data.url;
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  },
  methods: {},
};
